// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__STJNM","selected":"styles_selected__3TgN1","disabled":"styles_disabled__2h78R","icon":"styles_icon__TrmhK"};